import { useAuthStore } from '@/store/authStore';
import { useUIStore } from '@/store/uiStore';
import { useWaifus } from '@/api/queries';
import { WaifuCard } from '@/components/waifu/WaifuCard';
import { WaifuDetailOverlay } from '@/components/waifu/WaifuDetailOverlay';
import { RelationshipsOverlay } from '@/components/relationships/RelationshipsOverlay';

export function WaifusScreen() {
  const userId = useAuthStore((s) => s.userId);
  const setSelectedWaifuId = useUIStore((s) => s.setSelectedWaifuId);
  const { data, isLoading } = useWaifus(userId);
  const waifus = data?.waifus ?? [];

  return (
    <div className="flex-1 overflow-y-auto pb-24" style={{ paddingTop: 'calc(env(safe-area-inset-top) + 0.5rem)' }}>
      <div className="px-4 pt-4 pb-2 flex items-center justify-between">
        <h1 className="font-display text-2xl text-white">Waifus</h1>
      </div>
      <div className="px-4 space-y-2">
        {isLoading && <div className="text-white/40 text-sm">Загружаем…</div>}
        {!isLoading && waifus.length === 0 && (
          <div className="text-white/40 text-sm">Пока нет ни одной waifu.</div>
        )}
        {waifus.map((w) => (
          <WaifuCard key={w.id} waifu={w} onClick={() => setSelectedWaifuId(w.id)} />
        ))}
      </div>

      <WaifuDetailOverlay />
      <RelationshipsOverlay />
    </div>
  );
}
